export const config = {
    isTrustpilot: process.env.REACT_APP_ENV === 'trust'
};
